import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "flex xs6",
  style: {"font-size":"smaller"}
}
const _hoisted_3 = {
  key: 1,
  class: "flex xs6"
}
const _hoisted_4 = {
  key: 2,
  class: "flex xs6 offset--xs6"
}

import { Position } from "../models/Position";
import { computed, onMounted, ref, reactive } from "vue";
import { prettyNumber, roundToTwo } from "../Utilities";
import { Subscription } from "../models/Subscription";
import { UserChannel } from "../models/Channel";
import PositionEditor from "../components/PositionEditor.vue";

/* global defineProps */

export default /*#__PURE__*/_defineComponent({
  props: {
  position: { type: Position, required: true },
},
  setup(__props) {

const props = __props



const subscription = ref<Subscription | undefined>(undefined);
const channels = ref<UserChannel[]>([]);

onMounted(async () => {
  const sub = await props.position.fetchSubscription();
  subscription.value = sub;
  setupValues();
});

const setupValues = async (): Promise<void> => {
  if (subscription.value?.positionLow)
    lowValue.value = subscription.value?.positionLow;
  else lowValue.value = roundToTwo(props.position.value);
  if (subscription.value?.positionHigh)
    highValue.value = subscription.value?.positionHigh;
  else highValue.value = roundToTwo(props.position.value);
  const chans = await subscription.value?.channels();
  if (chans) channels.value = chans;
  else channels.value = [];
};

const intLowValue = ref(
  roundToTwo(subscription.value?.positionLow || props.position.value)
);
const lowValue = computed({
  get: () => intLowValue.value,
  set: (val) => {
    intLowValue.value = val;
  },
});

const intHighValue = ref(
  roundToTwo(props.position.positionHigh || props.position.value)
);
const highValue = computed({
  get: () => intHighValue.value,
  set: (val) => {
    intHighValue.value = val;
  },
});

const lowPositionViolated = computed((): boolean => {
  if (
    subscription.value == undefined ||
    subscription.value.positionLow == undefined
  )
    return false;
  return subscription.value.positionLow > props.position.value;
});

const lowPositionStyle = computed(() => {
  return {
    color: lowPositionViolated.value ? "red" : "",
  };
});
const highPositionViolated = computed((): boolean => {
  if (
    subscription.value == undefined ||
    subscription.value.positionHigh == undefined
  )
    return false;
  return subscription.value.positionHigh < props.position.value;
});

const highPositionStyle = computed(() => {
  return {
    color: highPositionViolated.value ? "red" : "",
  };
});

const show = ref(false);

const add = () => {
  show.value = true;
};
const edit = () => {
  show.value = true;
};
const deleteSub = () => {
  subscription.value?.destroy();
  subscription.value = undefined;
};

return (_ctx: any,_cache: any) => {
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (subscription.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (subscription.value.positionHigh)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  style: _normalizeStyle(_unref(highPositionStyle))
                }, [
                  _createVNode(_component_va_icon, {
                    name: "arrow_drop_up",
                    color: _unref(highPositionViolated) ? 'danger' : ''
                  }, null, 8, ["color"]),
                  _createTextVNode(" $" + _toDisplayString(_unref(prettyNumber)(subscription.value.positionHigh)), 1)
                ], 4))
              : _createCommentVNode("", true),
            (subscription.value.positionLow)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  style: _normalizeStyle(_unref(lowPositionStyle))
                }, [
                  _createVNode(_component_va_icon, {
                    name: "arrow_drop_down",
                    color: _unref(lowPositionViolated) ? 'danger' : ''
                  }, null, 8, ["color"]),
                  _createTextVNode(" $" + _toDisplayString(_unref(prettyNumber)(subscription.value.positionLow)), 1)
                ], 4))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (subscription.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_va_button, {
              icon: "edit",
              onClick: edit,
              size: "small"
            }),
            _createVNode(_component_va_button, {
              icon: "delete",
              onClick: deleteSub,
              color: "danger",
              class: "ml-1",
              size: "small"
            })
          ]))
        : _createCommentVNode("", true),
      (!subscription.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_va_button, {
              icon: "add",
              onClick: add,
              size: "small"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_va_modal, {
      modelValue: show.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((show).value = $event)),
      "no-dismiss": "",
      "hide-default-actions": ""
    }, {
      default: _withCtx(() => [
        _createVNode(PositionEditor, {
          position: props.position,
          subscription: subscription.value,
          onSaved: _cache[0] || (_cache[0] = ($event: any) => (show.value = false)),
          onCanceled: _cache[1] || (_cache[1] = ($event: any) => (show.value = false)),
          onLaunched: _cache[2] || (_cache[2] = ($event: any) => (show.value = false))
        }, null, 8, ["position", "subscription"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})